import INVENTORY_API_BASE_URL from "../../config/api";
import { useState, useEffect } from "react";
import Axios from "axios";
import "./returngrn.css";
import Table from "react-bootstrap/Table";
import swal from "sweetalert";
import Select from "react-select";
import logUserActivity from "../utils/logUserActivity";

function Returngrn() {
  const [listO, setListO] = useState([]);
  const [listgrn, setlistgrn] = useState([]);
  const [selectedSKU] = useState("defaultSKUValue");
  const [, setSelectedSKUTitle] = useState("");
  const [, setSelectedSKUedition] = useState("");
  const [, setSelectedSKUMedium] = useState("");
  const [, setSelectedSKUmrp] = useState("");
  const [returnQuantity] = useState("");
  const [returnGood] = useState("");
  const [, setReturnBad] = useState("");
  const [debitnote, setDebitNote] = useState("");
  const [termofdelivery, setTermOfDelivery] = useState("");
  const [otherreference, setotherreference] = useState("");
  const [dispatchthrough, setdispatchthrough] = useState("");
  const [destination, setdestination] = useState("");
  const [modeofpayment, setmodeofpayment] = useState("");
  const [selectedDate, setSelectedDate] = useState("");

  const [selectedSKUs, setSelectedSKUs] = useState([]);
  const [BiltyImg, setBiltyImg] = useState([]);

  const [selectedSKUData, setSelectedSKUData] = useState([]);
  const [selectedDistributorDiscount, setSelectedDistributorDiscount] =
    useState("");
  const [, setSelectedSKUdiscount] = useState("");

  const [totalReturnQuantity, setTotalReturnQuantity] = useState(0);
  const [totalValues, setTotalValues] = useState({});
  const [totalAmountValue, setTotalAmountValue] = useState(0);
  const [selectedDistributor, setSelectedDistributor] = useState(null);













  const handleSubmit = async () => {
    if (
      selectedDate === "" ||
      debitnote === "" ||
      selectedSKUs.length === 0 ||
      selectedSKUData.some(
        (skuData) =>
          skuData.returnQuantity === "" ||
          skuData.returnGood === "" ||
          skuData.returnBad === ""
      )
    ) {
      swal("Error!", " Star Mark are required.", "error");
      return;
    }

    const formData = new FormData();

    if (BiltyImg && BiltyImg.length > 0) {
      BiltyImg.forEach((file) => {
        formData.append("Bilty", file);
      });
    }

    const entriesData = selectedSKUData.map((skuData) => ({
      SKU: skuData.sku,
      Title: skuData.Title,
      Edition: skuData.Edition,
      Medium: skuData.Medium,
      mrp: skuData.mrp,
      discount: skuData.discount,
      HSNCode: skuData.HSNCode,
      Return_Quantity: skuData.returnQuantity,
      Good_Quantity: skuData.returnGood,
      Bad_Quantity: skuData.returnBad,
    }));

    formData.append("Entries", JSON.stringify(entriesData));
    formData.append("Invoice_Number", debitnote);
    formData.append("termofdelivery", termofdelivery);
    formData.append("otherreference", otherreference);
    formData.append("dispatchthrough", dispatchthrough);
    formData.append("destination", destination);
    formData.append("modeofpayment", modeofpayment);

    if (selectedDistributor) {
      formData.append("Distributor", selectedDistributor.value);
    }

    formData.append("Date", selectedDate);

    const totalQuantity = selectedSKUData.reduce(
      (total, skuData) => total + (parseInt(skuData.returnQuantity) || 0),
      0
    );

    formData.append("totalquantity", totalQuantity);

    const totalAmountValue = Object.values(totalValues).reduce((acc, val) => {
      if (!isNaN(parseFloat(val))) {
        return acc + parseFloat(val);
      }
      return acc;
    }, 0);
    formData.append("totalAmountValue", totalAmountValue.toFixed(2));

    try {
      await logUserActivity("RETURN_GRN_SUBMIT", {
        Distributor: selectedDistributor?.value || "",
        Date: selectedDate,
        Invoice_Number: debitnote,
        termofdelivery,
        otherreference,
        dispatchthrough,
        destination,
        modeofpayment,
        totalQuantity,
        totalAmountValue: totalAmountValue.toFixed(2),
        Entries: entriesData,
      });

      const response = await Axios.post(
        `${INVENTORY_API_BASE_URL}/postReturnGrn`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      swal({
        title: "Return Created",
        text: "",
        icon: "success",
      });

      window.location.reload();
    } catch (error) {
      console.error("Error submitting data:", error);
      swal("Error!", "Something went wrong!", "error");
    }
  };

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getCreatesuperdistributor`)
      .then((response) => {
        setListO(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getlist`)
      .then((respons) => {
        setlistgrn(respons.data);
      })
      .catch((erro) => {
        console.error("Error fetching data:", erro);
      });
  }, []);

  useEffect(() => {
    if (returnQuantity !== "" && returnGood !== "") {
      const returnBadValue = parseInt(returnQuantity) - parseInt(returnGood);
      setReturnBad(returnBadValue >= 0 ? returnBadValue.toString() : "");
    } else {
      setReturnBad("");
    }
  }, [returnQuantity, returnGood]);

  useEffect(() => {
    const updatedSelectedSKUData = selectedSKUData.map((item) => {
      if (item.returnQuantity !== "" && item.returnGood !== "") {
        const returnBadValue =
          parseInt(item.returnQuantity) - parseInt(item.returnGood);
        return {
          ...item,
          returnBad: returnBadValue >= 0 ? returnBadValue.toString() : "",
        };
      }
      return item;
    });
    setSelectedSKUData(updatedSelectedSKUData);
  }, [selectedSKUData]);

  const handleDistributorChange = (selectedOption) => {
    setSelectedDistributor(selectedOption);

    const selectedDistributor = listO.find(
      (distributor) => distributor.dname === selectedOption.value
    );

    setSelectedDistributorDiscount(selectedDistributor?.discount || "");

    const updatedSelectedSKUData = selectedSKUData.map((skuData) => ({
      ...skuData,
      discount: selectedDistributor?.discount || "",
    }));
    setSelectedSKUData(updatedSelectedSKUData);
  };

  useEffect(() => {
    if (selectedSKU !== "defaultSKUValue") {
      const selectedItem = listgrn.find((item) => item.sku === selectedSKU);
      setSelectedSKUTitle(selectedItem?.title || "");
      setSelectedSKUedition(selectedItem?.edition || "");
      setSelectedSKUMedium(selectedItem?.Medium || "");
      setSelectedSKUmrp(selectedItem?.mrp || "");
      setSelectedSKUdiscount(selectedItem?.discount || "");
    }
  }, [selectedSKU, listgrn]);

  useEffect(() => {
    const newTotalReturnQuantity = selectedSKUData.reduce(
      (total, skuData) => total + (parseInt(skuData.returnQuantity) || 0),
      0
    );

    setTotalReturnQuantity(newTotalReturnQuantity);
  }, [selectedSKUData]);

  useEffect(() => {
    const totalAmountValue = Object.values(totalValues).reduce((acc, val) => {
      if (!isNaN(parseFloat(val))) {
        return acc + parseFloat(val);
      }
      return acc;
    }, 0);

    setTotalAmountValue(totalAmountValue.toFixed(2));
  }, [totalValues]);

  useEffect(() => {
    if (returnQuantity !== "" && returnGood !== "") {
      const returnBadValue = parseInt(returnQuantity) - parseInt(returnGood);
      setReturnBad(returnBadValue >= 0 ? returnBadValue.toString() : "");
    } else {
      setReturnBad("");
    }
  }, [returnQuantity, returnGood]);

  const handleSKUChange = (selectedOption) => {
    const selectedValue = selectedOption.value;

    if (selectedSKUs.includes(selectedValue)) {
      swal("Warning", "This SKU is already selected.", "warning");
      return;
    }

    setSelectedSKUs([...selectedSKUs, selectedValue]);
    const selectedItem = listgrn.find((item) => item.sku === selectedValue);


    setSelectedSKUData([
      ...selectedSKUData,
      {
        sku: selectedValue,
        Title: selectedItem.title,
        Edition: selectedItem.edition || "",
        Medium: selectedItem.Medium || "",
        mrp: selectedItem.mrp || "",
        HSNCode: selectedItem.Hsncode || "",
        discount: selectedDistributorDiscount || "",
        returnQuantity: "",
        returnGood: "",
        returnBad: "",
      },
    ]);

    setTotalValues((prevTotalValues) => ({
      ...prevTotalValues,
      [selectedValue]: "",
    }));
  };

  const handleReturnQuantityChange = (index, event) => {
    const newSelectedSKUData = [...selectedSKUData];
    newSelectedSKUData[index].returnQuantity = event.target.value;
    setSelectedSKUData(newSelectedSKUData);

    const discountValue = calculateDiscountValue(
      newSelectedSKUData[index].mrp,
      newSelectedSKUData[index].discount
    );
    const totalValue = calculateTotalValue(event.target.value, discountValue);

    setTotalValues((prevTotalValues) => ({
      ...prevTotalValues,
      [newSelectedSKUData[index].sku]: totalValue,
    }));

    const returnGoodValue = event.target.value || 0;
    newSelectedSKUData[index].returnGood = returnGoodValue;
    setSelectedSKUData(newSelectedSKUData);

    const returnBadValue =
      parseInt(returnGoodValue) -
        parseInt(newSelectedSKUData[index].returnGood) || 0;
    newSelectedSKUData[index].returnBad =
      returnBadValue >= 0 ? returnBadValue.toString() : "";
    setSelectedSKUData(newSelectedSKUData);
  };

  const handlereturnGoodChange = (index, event) => {
    const newSelectedSKUData = [...selectedSKUData];
    newSelectedSKUData[index].returnGood = event.target.value;
    setSelectedSKUData(newSelectedSKUData);
  };

  const handlereturnBadChange = (index, event) => {
    const newSelectedSKUData = [...selectedSKUData];
    const returnBadValue = parseInt(event.target.value) || 0;
    const returnGoodValue =
      parseInt(newSelectedSKUData[index].returnQuantity) - returnBadValue || 0;

    newSelectedSKUData[index].returnBad = returnBadValue.toString();
    newSelectedSKUData[index].returnGood = returnGoodValue.toString();

    setSelectedSKUData(newSelectedSKUData);

    const discountValue = calculateDiscountValue(
      newSelectedSKUData[index].mrp,
      newSelectedSKUData[index].discount
    );
    const totalValue = calculateTotalValue(returnGoodValue, discountValue);

    setTotalValues((prevTotalValues) => ({
      ...prevTotalValues,
      [newSelectedSKUData[index].sku]: totalValue,
    }));
  };

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const handleDelete = (sku) => {
    const updatedSelectedSKUData = selectedSKUData.filter(
      (skuData) => skuData.sku !== sku
    );
    setSelectedSKUData(updatedSelectedSKUData);

    setSelectedSKUs(selectedSKUs.filter((selectedSku) => selectedSku !== sku));

    setTotalValues((prevTotalValues) => {
      const updatedTotalValues = { ...prevTotalValues };
      delete updatedTotalValues[sku];
      return updatedTotalValues;
    });

    const updatedTotalAmountValue = Object.values(totalValues)
      .filter((_, key) => key !== sku) 
      .reduce((acc, val) => {
        if (!isNaN(parseFloat(val))) {
          return acc + parseFloat(val);
        }
        return acc;
      }, 0);

    setTotalAmountValue(updatedTotalAmountValue.toFixed(2));
  };
  const calculateDiscountValue = (mrp, discount) => {
    if (mrp && discount) {
      const mrpValue = parseFloat(mrp);
      const discountValue = parseFloat(discount);
      const discountedValue = (mrpValue * discountValue) / 100;
      return (mrpValue - discountedValue).toFixed(2);
    }
    return "";
  };

  const calculateTotalValue = (returnQuantity, discountValue) => {
    if (returnQuantity && discountValue) {
      const returnQty = parseInt(returnQuantity);
      const discountedValue = parseFloat(discountValue);
      return (returnQty * discountedValue).toFixed(2);
    }
    return "";
  };

  return (
    <main className="returngrn-page">
      <div className="returngrn-shell">
        <header className="returngrn-hero">
          <div>
            <p className="returngrn-eyebrow">
              <span aria-hidden="true" />
              WAREHOUSE OPERATIONS / RETURNS
            </p>
            <h1>Create Return GRN</h1>
            <p>Record returned stock, classify condition, and submit the return document.</p>
          </div>
          <div className="returngrn-document-badge">
            <span>RETURN DOCUMENT</span>
            <strong>Goods received note</strong>
            <small><i aria-hidden="true" /> Ready for entry</small>
          </div>
        </header>

        <section className="returngrn-summary" aria-label="Return totals">
          <article className="returngrn-summary-card">
            <span className="returngrn-summary-icon returngrn-summary-icon--blue" aria-hidden="true">Q</span>
            <div>
              <span className="returngrn-summary-label">Total return quantity</span>
              <strong>{totalReturnQuantity.toLocaleString()}</strong>
              <small>Units recorded in this return</small>
            </div>
          </article>
          <article className="returngrn-summary-card">
            <span className="returngrn-summary-icon returngrn-summary-icon--green" aria-hidden="true">₹</span>
            <div>
              <span className="returngrn-summary-label">Total amount value</span>
              <strong>₹ {totalAmountValue}</strong>
              <small>Calculated from good return units</small>
            </div>
          </article>
          <article className="returngrn-summary-card returngrn-summary-card--count">
            <span className="returngrn-summary-icon returngrn-summary-icon--violet" aria-hidden="true">SKU</span>
            <div>
              <span className="returngrn-summary-label">Items in return</span>
              <strong>{selectedSKUData.length.toLocaleString()}</strong>
              <small>Selected SKU{selectedSKUData.length === 1 ? "" : "s"}</small>
            </div>
          </article>
        </section>

        <section className="returngrn-card" aria-labelledby="returngrn-details-title">
          <div className="returngrn-card-heading">
            <span className="returngrn-step" aria-hidden="true">01</span>
            <div>
              <h2 id="returngrn-details-title">Return details</h2>
              <p>Choose the distributor and the date the returned goods were received.</p>
            </div>
          </div>
          <div className="returngrn-selection-grid">
            <div className="returngrn-field">
              <label className="returngrn-field-label" htmlFor="returngrn-distributor">
                Distributor <span className="returngrn-required">*</span>
              </label>
              <Select
                className="distributorheight returngrn-select"
                classNamePrefix="returngrn-select"
                id="returngrn-distributor"
                name="distributor"
                value={selectedDistributor}
                options={listO.map((distributor) => ({
                  value: distributor.dname,
                  label: distributor.dname,
                }))}
                onChange={handleDistributorChange}
                isSearchable
                placeholder="Search or select a distributor"
              />
            </div>
            <div className="returngrn-field">
              <label className="returngrn-field-label" htmlFor="returngrn-date">
                Return date <span className="returngrn-required">*</span>
              </label>
              <input
                id="returngrn-date"
                className="returngrn-input"
                type="date"
                value={selectedDate}
                onChange={handleDateChange}
              />
            </div>
          </div>
          <p className="returngrn-card-note">
            <span aria-hidden="true">i</span>
            Fields marked with an asterisk are required before submission.
          </p>
        </section>

        <section className="returngrn-card" aria-labelledby="returngrn-items-title">
          <div className="returngrn-card-heading">
            <span className="returngrn-step returngrn-step--green" aria-hidden="true">02</span>
            <div>
              <h2 id="returngrn-items-title">Returned items</h2>
              <p>Add SKUs, enter quantities, and mark each unit as good or damaged.</p>
            </div>
          </div>

          <div className="returngrn-add-sku">
            <div>
              <label className="returngrn-field-label" htmlFor="returngrn-sku">Add a SKU</label>
              <p>Search by SKU, title, or medium to add an item to this return.</p>
            </div>
            <Select
              className="skuheight returngrn-select returngrn-select--sku"
              classNamePrefix="returngrn-select"
              inputId="returngrn-sku"
              name="sku"
              value={selectedSKU}
              options={listgrn.map((item) => ({
                value: item.sku,
                label: item.sku + " - " + item.title + " - " + item.Medium,
              }))}
              onChange={handleSKUChange}
              isSearchable
              placeholder="Search and select a SKU"
            />
          </div>

          {selectedSKUData.length > 0 ? (
            <div className="returngrn-table-wrap">
              <table className="returngrn-table">
                <thead>
                  <tr>
                    {[
                      "S.No",
                      "Title",
                      "SKU",
                      "Edition",
                      "Medium",
                      "MRP",
                      "Discount (%)",
                      "Selling price",
                      "Return quantity *",
                      "SKU value (₹)",
                      "Good *",
                      "Bad",
                      "Action",
                    ].map((head, idx) => (
                      <th key={idx} scope="col">{head}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {selectedSKUData.map((skuData, index) => {
                    const selectedItem = listgrn.find((item) => item.sku === skuData.sku);
                    const discountValue = calculateDiscountValue(skuData.mrp, skuData.discount);

                    return (
                      <tr key={skuData.sku || index}>
                        <td className="returngrn-row-number">{String(index + 1).padStart(2, "0")}</td>
                        <td className="returngrn-title-cell" title={selectedItem?.title || skuData.Title || ""}>
                          {selectedItem?.title || skuData.Title || "—"}
                        </td>
                        <td><span className="returngrn-sku-pill">{selectedItem?.sku || skuData.sku}</span></td>
                        <td>{selectedItem?.edition || skuData.Edition || "—"}</td>
                        <td>{selectedItem?.Medium || skuData.Medium || "—"}</td>
                        <td>{selectedItem?.mrp || skuData.mrp || "—"}</td>
                        <td>{selectedDistributorDiscount || "—"}</td>
                        <td className="returngrn-money-cell">{discountValue ? "₹ " + discountValue : "—"}</td>
                        <td>
                          <input
                            className="returngrn-number-input"
                            type="number"
                            value={skuData.returnQuantity}
                            onChange={(event) => handleReturnQuantityChange(index, event)}
                            onWheel={(e) => e.target.blur()}
                            aria-label={"Return quantity for " + skuData.sku}
                          />
                        </td>
                        <td className="returngrn-money-cell">
                          {totalValues[skuData.sku] ? "₹ " + totalValues[skuData.sku] : "—"}
                        </td>
                        <td>
                          <input
                            className="returngrn-number-input"
                            type="number"
                            value={skuData.returnGood}
                            onChange={(event) => handlereturnGoodChange(index, event)}
                            onWheel={(e) => e.target.blur()}
                            aria-label={"Good quantity for " + skuData.sku}
                          />
                        </td>
                        <td>
                          <input
                            className="returngrn-number-input"
                            type="number"
                            value={skuData.returnBad}
                            onChange={(event) => handlereturnBadChange(index, event)}
                            onWheel={(e) => e.target.blur()}
                            aria-label={"Bad quantity for " + skuData.sku}
                          />
                        </td>
                        <td>
                          <button
                            className="returngrn-delete-button"
                            type="button"
                            onClick={() => handleDelete(skuData.sku)}
                            aria-label={"Remove " + skuData.sku}
                          >
                            Remove
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="returngrn-empty-state">
              <span className="returngrn-empty-icon" aria-hidden="true">＋</span>
              <strong>No items added yet</strong>
              <p>Search for a SKU above to start building this return.</p>
            </div>
          )}
        </section>

        <section className="returngrn-card" aria-labelledby="returngrn-document-title">
          <div className="returngrn-card-heading">
            <span className="returngrn-step returngrn-step--violet" aria-hidden="true">03</span>
            <div>
              <h2 id="returngrn-document-title">Document and delivery information</h2>
              <p>Complete the invoice references and attach the return bilty if available.</p>
            </div>
          </div>

          <div className="returngrn-form-grid">
            {[
              {
                label: "Original debit note / invoice number",
                required: true,
                value: debitnote,
                onChange: (e) => setDebitNote(e.target.value),
              },
              {
                label: "Other reference",
                value: otherreference,
                onChange: (e) => setotherreference(e.target.value),
              },
              {
                label: "Mode of payment",
                value: modeofpayment,
                onChange: (e) => setmodeofpayment(e.target.value),
              },
              {
                label: "Destination",
                value: destination,
                onChange: (e) => setdestination(e.target.value),
              },
              {
                label: "Dispatch through",
                value: dispatchthrough,
                onChange: (e) => setdispatchthrough(e.target.value),
              },
              {
                label: "Terms of delivery",
                value: termofdelivery,
                onChange: (e) => setTermOfDelivery(e.target.value),
              },
            ].map((item, idx) => (
              <div className="returngrn-field" key={idx}>
                <label className="returngrn-field-label" htmlFor={"returngrn-meta-" + idx}>
                  {item.label}
                  {item.required && <span className="returngrn-required"> *</span>}
                </label>
                <input
                  id={"returngrn-meta-" + idx}
                  className="returngrn-input"
                  type="text"
                  value={item.value}
                  onChange={item.onChange}
                />
              </div>
            ))}
          </div>

          <div className="returngrn-upload">
            <div>
              <label className="returngrn-field-label" htmlFor="returngrn-bilty">Upload bilty</label>
              <p>Attach one or more image or PDF files.</p>
            </div>
            <input
              id="returngrn-bilty"
              className="returngrn-file-input"
              type="file"
              accept="image/*,application/pdf"
              multiple
              onChange={(e) => setBiltyImg([...e.target.files])}
            />
            {BiltyImg.length > 0 && (
              <div className="returngrn-file-list">
                {BiltyImg.map((file, index) => (
                  <span className="returngrn-file-chip" key={file.name + index}>{file.name}</span>
                ))}
              </div>
            )}
          </div>
        </section>

        <footer className="returngrn-submit-bar">
          <div className="returngrn-submit-copy">
            <strong>Ready to submit?</strong>
            <span>
              {selectedSKUData.length.toLocaleString()} item{selectedSKUData.length === 1 ? "" : "s"}
              {" · "}Quantity {totalReturnQuantity.toLocaleString()}
              {" · "}₹ {totalAmountValue}
            </span>
          </div>
          <button
            className="returngrn-submit-button"
            type="button"
            onClick={handleSubmit}
          >
            Submit return GRN <span aria-hidden="true">→</span>
          </button>
        </footer>
      </div>
    </main>
  );

}

export default Returngrn;
